module.exports = __webpack_public_path__ + "static/metal-frame09-749d2d6794668a3a38e1208ab9ca1798.jpg";